module.exports = __webpack_public_path__ + "static/media/React1.bfc4bc33.jpg";